import React from 'react';
import { makeStyles } from '@mui/styles';
import { Paper, Box, Button } from '@mui/material';
import { t } from 'i18next';
import BackButton from '../backButton';
import BiColorHeader from '../biColorHeader/BiColorHeader';
import { buttonStyle } from '../customSelect/ActionDropDown';

const useStyles = makeStyles((theme) => ({
    backButton: {
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        marginBottom: theme.spacing(2),
    },
    content: {
        padding: theme.spacing(2),
        margin: '12px',
    },
    button: buttonStyle,
}));

const DetailsPage = ({ children, onBackClick, leftText, rightText, stepperForwardHandler, buttonText = 'Move Record' }) => {
    const classes = useStyles();

    return (
        <Box sx={{ height: '100%' }}>
            <Box sx={{ padding: '16px' }}>
                <BackButton
                    className={classes.backButton}
                    onClick={onBackClick}
                    text={t('Record.BackButtonLabel')}
                />
                <BiColorHeader
                    left={leftText}
                    right={rightText}
                />
                <Paper className={classes.content}>
                    {children}
                    <Box style={{ minHeight: '500px' }} />
                </Paper>
            </Box>
            <Box
                style={{
                    position: 'sticky',
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    boxShadow: '6px -2px 13px 1px rgba(188,188,188, 0.37)',
                    opacity: 1,
                    backgroundColor: 'rgba(247,249,252, 1)',
                    padding: '16px 48px',
                }}
            >
                <Button
                    sx={{ ...buttonStyle }}
                    onClick={stepperForwardHandler}
                >
                    {buttonText}
                </Button>
            </Box>
        </Box>
    );
};

export default DetailsPage;
